import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import { store } from 'components/Store';
import { useContext } from 'react';
const useGetRemainingCredits = () => {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const { generalApiCall } = useGeneralApiCall();

  const getRemainingCredits = async ({ source }) => {
    try {
      let pathname = '/api/writing-assistant-generated-content/remaining-credits-this-month';
      let method = 'get';
      let results = await generalApiCall({
        pathname,
        method,
        needsAuthentication: true,
        requestSource: source,
        notShowErrorMessage: true,
        returnError: true,
      });
      return results;
    } catch (error) {}
  };
  const updateRemainingCredits = async () => {
    try {
      let remainingCredits = await getRemainingCredits({});
      if (typeof remainingCredits !== 'undefined') {
        dispatch({ type: 'MODIFY_SECTION', parameter: 'remainingCredits', value: remainingCredits });
      }
    } catch (error) {}
  };
  return { getRemainingCredits, updateRemainingCredits };
};

export default useGetRemainingCredits;
